import Breadcrumb from "../components/Reusable/Breadcrumb";
import React from "react";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className="terms-main-container">
      <Breadcrumb title={t("terms_page")} returnPage="/informations" />

      <div className="terms-content">
        <div dangerouslySetInnerHTML={{ __html: t("terms.content") }} />

        {/* <h2>{t("terms.general_rules.title")}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: t("terms.general_rules.description"),
          }}
        />

        <h3>{t("terms.user_obligations.title")}</h3>
        <ul>
          {t("terms.user_obligations.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <h3>{t("terms.strictly_prohibited.title")}</h3>
        <ul>
          {t("terms.strictly_prohibited.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <h2>{t("terms.disclaimer.title")}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: t("terms.disclaimer.description"),
          }}
        />

        <h2>{t("terms.policy_changes.title")}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: t("terms.policy_changes.description"),
          }}
        />

        <h2>{t("terms.privacy_policy.title")}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: t("terms.privacy_policy.description"),
          }}
        />

        <h3>{t("terms.personal_data.title")}</h3>
        <ul>
          {t("terms.personal_data.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <h3>{t("terms.user_rights.title")}</h3>
        <ul>
          {t("terms.user_rights.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p>
          {t("terms.contact.text")}{" "}
          <a href={`mailto:${t("terms.contact.email")}`}>
            {t("terms.contact.email")}
          </a>
        </p>

        <p>{t("terms.version")}</p> */}
      </div>
    </div>
  );
};

export default Terms;
